/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_UploadingInputs */



/**
* | output |
* | --- |
* | "Uploading..." |
*
* @param {Deck_Upload_UploadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_uploading = /** @type {((inputs?: Deck_Upload_UploadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_UploadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléchargement...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviando...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento...")
	return /** @type {LocalizedString} */ ("Uploading...")
});